import { useFormikContext } from "formik";
import Col from "./col";
import Icon from "./icon";
import Row from "./row";
import { useDispatch, useSelector } from "react-redux";
import { getCartInfo, updateCart } from "../../redux/reducer/cart.reducer";
import { showToast } from "../../helpers/show.toast";
import { handleCatchError } from "../../helpers/handle.catch.error";

export default function Quantity(props) {
  const {
    name,
    max,
    quantity = 1,
    className,
    small,
    id,
    handleRemoveItem,
  } = props;

  const dispatch = useDispatch();
  const { updateCartLoading, cartInfoLoading } = useSelector(
    (state) => state.cart
  );

  const formik = useFormikContext();

  const handleChangeQuantity = (action) => {
    let value = formik?.values.quantity || quantity;

    if (updateCartLoading || cartInfoLoading) {
      return;
    }

    if (action === "minus") {
      if (value > 1) {
        value -= 1;
      } else {
        handleRemoveItem(id);

        return;
      }
    }

    if (action === "plus") {
      if (max && value >= max) {
        showToast(
          "Stock limit reached!",
          `Only left ${max} quantity for this product or its variants.`,
          "warning"
        );

        return;
      }

      value += 1;
    }

    if (id) {
      dispatch(
        updateCart({
          id: id,
          quantity: value,
        })
      )
        .unwrap()
        .then((res) => {
          dispatch(getCartInfo());
          showToast(
            "Cart updated!",
            "The cart item quantity is updated successful.",
            "success"
          );
        })
        .catch((ex) => showToast(handleCatchError(ex, null)));

      return;
    }

    formik?.setFieldValue(name, value);
  };

  return (
    <Row
      className={`element _quantity ${small ? "--small" : ""} ${
        className ? className : ""
      }`}
    >
      <Col
        className="col-center pointer"
        onClick={() => handleChangeQuantity("minus")}
      >
        <Icon icon="mdi:minus" />
      </Col>
      <Col className="col-center">
        <p>{formik?.values?.quantity || quantity}</p>
      </Col>
      <Col
        className="col-center pointer"
        onClick={() => handleChangeQuantity("plus")}
      >
        <Icon icon="mdi:add" />
      </Col>
    </Row>
  );
}
